import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

export const LoadingView = (props) => {
    const width = window.innerWidth + "px";
    const height = window.innerHeight + "px";
    return (
        <Body Width={width} Height={height} Display={props.Display}>
            <ItemA />
            <ItemB />
            <ItemC />
            <Text>Loading...</Text>
        </Body>
    );
}

LoadingView.propTypes = {
    Display: PropTypes.bool,
};

const Body = styled.div`
    width: ${props => (props.Width)};
    height: ${props => (props.Height)};
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.8);

    z-index: 100;

    opacity: ${props => (props.Display ? 1 : 0)};
    pointer-events: ${props => (props.Display ? "" : "none")};

    transition-duration: 0.2s;
`;

const Text = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #444444;
`;

const animeA = keyframes`
    0% {transform:  translate(-50%, -50%) rotate(0deg)   scaleX(0.90) scaleY(1.00);}
   50% {transform:  translate(-50%, -50%) rotate(180deg) scaleX(0.90) scaleY(1.00);}
  100% {transform:  translate(-50%, -50%) rotate(360deg) scaleX(0.90) scaleY(1.00);}
`;
const animeB = keyframes`
    0% {transform:  translate(-50%, -50%) rotate(31deg)  scaleX(0.90) scaleY(1.00);}
   25% {transform:  translate(-50%, -50%) rotate(121deg) scaleX(1.00) scaleY(0.90);}
   50% {transform:  translate(-50%, -50%) rotate(211deg) scaleX(0.90) scaleY(1.00);}
   75% {transform:  translate(-50%, -50%) rotate(301deg) scaleX(1.00) scaleY(0.90);}
  100% {transform:  translate(-50%, -50%) rotate(391deg) scaleX(0.90) scaleY(1.00);}
`;
const animeC = keyframes`
    0% {transform:  translate(-50%, -50%) rotate(413deg) scaleX(0.90) scaleY(1.00);}
   50% {transform:  translate(-50%, -50%) rotate(233deg) scaleX(0.90) scaleY(1.00);}
  100% {transform:  translate(-50%, -50%) rotate(53deg)  scaleX(0.90) scaleY(1.00);}
`;

const ItemA = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 100px;
    height: 100px;
    border-radius: 50%;
    mix-blend-mode: screen;
    background-color: rgba(255, 0, 0, 1);

    animation: ${animeA} linear 6s;
    animation-iteration-count: infinite;
`;
const ItemB = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 100px;
    height: 100px;
    border-radius: 50%;
    mix-blend-mode: screen;
    background-color: rgba(0, 255, 0, 1);

    animation: ${animeB} linear 6s;
    animation-iteration-count: infinite;
`;
const ItemC = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 100px;
    height: 100px;
    border-radius: 50%;
    mix-blend-mode: screen;
    background-color: rgba(0, 0, 255, 1);

    animation: ${animeC} linear 6s;
    animation-iteration-count: infinite;
`;
